module.exports = __webpack_public_path__ + "static/img/banner.713c3aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = omhf
// module chunks = 2